import Player from '@FreeRider/Player/Player';
import Cartesian from '@FreeRider/Utils/Cartesian';
import Trick from '@FreeRider/Player/Trick';

abstract class BaseVehicle
{
    private static readonly GRAVITY_X = 0;
    private static readonly GRAVITY_Y = 0.3;

    public player: Player;
    public slow: boolean;
    public gravity: Cartesian;
    public trick: Trick;
    public stable: boolean;

    constructor(player: Player)
    {
        this.player = player;
        this.slow = false;
        this.trick = new Trick();
        this.stable = false;

        this.gravity = {
            x: BaseVehicle.GRAVITY_X,
            y: BaseVehicle.GRAVITY_Y
        }
    }
}

export default BaseVehicle